module.exports = __webpack_public_path__ + "img/65a9c768cbcbb75e20b9b2a167021ab2.png";